import React from 'react'
import { Link } from 'react-router-dom'

export default function HomeSolutions() {
  return (
    <>

      <section className="home-solutions">
        <img src="/assets/images/solution-bg.webp" className="banner-bg" alt="Solution"  loading="lazy"/>
        <img src="/assets/images/cross-img.webp" className="cross-img" alt="Solution" loading="lazy" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
              <div className="wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="2s">
                <div className="solutions-text heading-center">
                  <span className="subtitle">Innovative Intelligence</span>
                  <h1 className="heading">Stay Ahead with Smart  <span className="theme-style">AI-Driven </span> <br /> Logistics Solutions </h1>
                  <p>Mobility Infotech leverages cutting-edge AI and real-time data to eliminate guesswork, optimize inventory, reduce operational waste, and ensure products are always available when needed. By transforming raw data into actionable insights, it enables smarter, faster decision making across your supply chain. The result? Highly efficient, adaptive, and resilient supply chains capable of navigating dynamic market demands, driving sustained growth, and securing a lasting competitive edge.</p>
                  <div className="home-btn">
                    <Link className="theme-btn" to="/route-optimization-and-planning"> <span>Explore More</span> </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
